import EWAI_LOGO from "./EagleWorksLogo.png";
export default EWAI_LOGO;
